import { render, staticRenderFns } from "./CustomerGroupList.vue?vue&type=template&id=c72a3dbc&"
import script from "./CustomerGroupList.vue?vue&type=script&lang=js&"
export * from "./CustomerGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports